module.exports = __webpack_public_path__ + "img/symbol_9.75f541a5.png";